class ExpandingGallery extends HTMLElement {
  constructor() {
    super();
    this.panels = Array.from(this.querySelectorAll('[data-eg-panel]'));
    this.toggles = Array.from(this.querySelectorAll('[data-eg-toggle]'));
    this.autoRotate = this.dataset.autorotate === 'true';
    this.interval = (parseInt(this.dataset.interval, 10) || 5) * 1000;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.activeIndex = this.panels.findIndex((panel) => panel.classList.contains('is-active'));
    if (this.activeIndex < 0) this.activeIndex = 0;

    this.toggles.forEach((btn, i) => {
      btn.addEventListener('click', () => this.setActive(i));
    });

    this.stopRotate = this.stopRotate.bind(this);
    this.startRotate = this.startRotate.bind(this);
    this.addEventListener('mouseenter', this.stopRotate);
    this.addEventListener('mouseleave', this.startRotate);
    this.addEventListener('focusin', this.stopRotate);
    this.addEventListener('focusout', this.startRotate);

    this.startRotate();
  }

  connectedCallback() {
    if (window.Shopify && Shopify.designMode) {
      this.onBlockSelect = (event) => {
        const panel = event.target.closest ? event.target.closest('[data-eg-panel]') : null;
        if (panel && this.contains(panel)) this.setActive(this.panels.indexOf(panel), true);
      };
      this.onBlockDeselect = (event) => {
        const panel = event.target.closest ? event.target.closest('[data-eg-panel]') : null;
        if (panel && this.contains(panel)) this.setActive(0, true);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
    }
  }

  disconnectedCallback() {
    this.stopRotate();
    if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
    if (this.onBlockDeselect) document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
  }

  setActive(index, force) {
    if (index < 0 || index >= this.panels.length) return;
    if (index === this.activeIndex && !force) return;
    this.panels.forEach((panel, i) => {
      const isActive = i === index;
      panel.classList.toggle('is-active', isActive);
      const toggle = this.toggles[i];
      if (toggle) toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      const content = panel.querySelector('[data-eg-content]');
      if (content) content.toggleAttribute('inert', !isActive);
    });
    this.activeIndex = index;
  }

  next() {
    this.setActive((this.activeIndex + 1) % this.panels.length);
  }

  startRotate() {
    if (!this.autoRotate || this.reduceMotion || this.panels.length < 2) return;
    this.stopRotate();
    this.timer = setInterval(() => this.next(), this.interval);
  }

  stopRotate() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}

if (!customElements.get('expanding-gallery')) {
  customElements.define('expanding-gallery', ExpandingGallery);
}
